import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import {GroupBadge} from "../../../../designSystem/components/GroupBadge";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {DataCardLayout} from "../../../../designSystem/components/DataCardLayout";
import {Typography} from "../../../../designSystem/components/Typography";

export const OrganizationTable = ({
  sortColumn,
  sortOrder,
  organizations,
  handleSort,
  handleEdit,
  handleDelete,
}) => (
  <div>
    {/* Table for md and above */}
    <div className="hidden md:block">
      <table className="w-full table-fixed border shadow-lg rounded-2xl overflow-hidden">
        <thead>
        <tr className="bg-white">
          <th
            className="p-2 border cursor-pointer"
            onClick={() => handleSort("name")}
          >
            名稱{" "}
            {sortColumn === "name" ? (
              <FontAwesomeIcon icon={sortOrder === "asc" ? faSortUp : faSortDown}/>
            ) : null}
          </th>
          <th>組別</th>
          <th className="p-2 border resize-x overflow-auto w-[200px]">
            動作
          </th>
        </tr>
        </thead>
        <tbody>
        {organizations.map(org => (
          <tr key={org.id} className="border bg-white">
            <td className="p-2 border">{org.name}</td>
            <td className="p-2 border">
              <div className="flex flex-wrap gap-2">
                {org.group.map((groupName: string) => (
                  <GroupBadge
                    key={groupName}
                    groupName={groupName}
                  />
                ))}
              </div>
            </td>
            <td className="p-2 border">
              <ActionButton
                size="sm"
                label="編輯"
                iconName="fa-edit"
                variant="ghost"
                onClick={() => handleEdit(org)}
              />
              <ActionButton
                size="sm"
                label="刪除"
                iconName="fa-trash"
                color="warning"
                variant="ghost"
                onClick={() => handleDelete(org)}
              />
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>

    {/* Card view for small screens */}
    <div className="md:hidden space-y-4">
      {organizations.map((org, index) => (
        <DataCardLayout
          key={`org${index}`}
          mainInfoSection={
            <React.Fragment>
              <Typography variant="title">
                {org.name}
              </Typography>
              <div className="flex flex-row gap-2 items-start">
                <Typography variant="bodyBold" className="text-nowrap">
                  屏衛權限:
                </Typography>
                <div className="flex gap-2 overflow-x-scroll">
                  {org.group.map(groupName => (
                    <GroupBadge groupName={groupName} key={groupName}/>
                  ))}
                </div>
              </div>
            </React.Fragment>
          }
          actionSection={
            <React.Fragment>
              <ActionButton
                label="編輯"
                iconName="fa-edit"
                variant="outline"
                onClick={() => handleEdit(org)}
              />
              <ActionButton
                label="刪除"
                iconName="fa-trash"
                color="warning"
                variant="outline"
                onClick={() => handleDelete(org)}
              />
            </React.Fragment>
          }
        />
      ))}
    </div>
  </div>
);
